import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';
import { IFilter } from './_types';

export const getAllFilterForUser = (): Promise<IFilter[] | boolean> =>
  api()
    .get(`/portal-api/searchFilter/getAllForUser`)
    .then((response) => get(response, 'data'))
    .catch((error) => false);
